export default __webpack_public_path__ + "static/media/deposits.1f59f534.svg";